import InfiniteScroll from "react-infinite-scroll-component";

import "./albums.css";
import {
  MoreOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  CheckSquareOutlined,
  DeleteOutlined,
  BlockOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Divider,
  List,
  theme,
  Dropdown,
  Card,
  Modal,
  message,
  Spin,
  Empty,
  FloatButton,
  Input,
  Form,
} from "antd";
import { useEffect, useState } from "react";
import DefaultLayout from "../../components/defaultLayout";
import Meta from "antd/es/card/Meta";
import { useNavigate } from "react-router-dom";
import { Album } from "../../api";
import { IMAGEBASEPATH } from "../../environment";
import authService from "../../services/auth.service";

const Albums = () => {
  const [loading, setLoading] = useState(false);
  const [albums, setAlbums] = useState();
  const [currentAlbumIndex, setCurrentAlbumIndex] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [allAlbums, setAllAlbums] = useState([]);
  const [openEditNameModal, setOpenEditNameModal] = useState(false);
  const [editAlbumNameValue, setEditAlbumNameValue] = useState();
  const [addAlbumNameValue, setAddAlbumNameValue] = useState();
  
  const [openAddAlbumModal, setOpenAddAlbumModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [selectedElements, setSelectedElements] = useState([]);
  const [modeSelectEnabled, setModeSelectEnabled] = useState(false);
  const navigate = useNavigate();
 

  const removeModal = (index) => {
    modal.confirm({
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content:
        "Are you sure you want to delete the album " +
        allAlbums[index].name,
      okText: "Yes",
      cancelText: "No",
      onOk: () => removeAlbums([allAlbums[index].id]),
    });
  };

  const removeAlbums = async (ids) => {
    setLoading(true);

    if (ids.length) {
      const id = ids.pop();
      const album = allAlbums.find((a) => a.id === id);
      console.log(ids);
      Album.remove({ id })
        .then((response) => {
          console.log(response);

          message.success(`Album ${album.name} successfully removed !`);
          setAllAlbums((prevAlbums) =>
            prevAlbums.filter((a) => a.id !== id)
          );
          setAlbums((prevAlbums) =>
            prevAlbums.filter((a) => a.id !== id)
          );
          removeAlbums(ids);
        })

        .catch((e) => {
          message.error(`An error occured while deleting ${album.name} !`);
        });
    } else {
      setLoading(false);
    }
  };

  const editAlbumName = () => {
 
    if (!!!editAlbumNameValue) {
      message.error("Album name cannot be empty !");
      return;
    }
    

    setLoading(true);
    hideEditAlbumModal();
    Album.edit({ ...albums[currentAlbumIndex], name : editAlbumNameValue })
      .then((updatedAlbum) => {
        setLoading(false);

        message.success(`Album ${editAlbumNameValue} successfully edited !`);
        console.log(updatedAlbum);

        albums[currentAlbumIndex] = updatedAlbum;

        let index = allAlbums.findIndex(
          (e) => e.id === updatedAlbum.id
        );
        if (index >= 0) {
          const allAlbums_tmp = allAlbums;
          allAlbums_tmp[index] = updatedAlbum;
          setAllAlbums(allAlbums_tmp);
        }
        setAlbums(albums);
      })
      .catch((e) => {
        message.error(`An error occured !`);
        setLoading(false);
      });
  };

  const createAlbum = () => {
 
    if (!!!addAlbumNameValue) {
      message.error("Album name cannot be empty !");
      return;
    }
 
    setLoading(true);
    hideAddAlbumModal();
    setAddAlbumNameValue("");
    setEditAlbumNameValue("");
    Album.create({ name : addAlbumNameValue , user :  authService.getCurrentUser().user.id })
      .then((newAlbum) => {
        if (newAlbum.code === 409) {
          message.error(
            `Album ${addAlbumNameValue}} already exists. Choose new meausures !`
          );
          setLoading(false);
          return;
        }
        message.success(`Album ${addAlbumNameValue} successfully created !`);
        console.log(newAlbum);
        setAlbums([newAlbum, ...albums]);
        setAllAlbums([newAlbum, ...allAlbums]);
        setLoading(false);
      })
      .catch((e) => {
        message.error(`An error occured !`);
        setLoading(false);
      });
  };
  const showEditModal = (index) => {
     setEditAlbumNameValue(albums[index].name);
    console.log(albums[index].height);
    setOpenEditNameModal(true);
  };

  const hideEditAlbumModal = () => {
    setOpenEditNameModal(false);
  };
  const showAddAlbumModal = () => {
    setAddAlbumNameValue(null);
 
    setOpenAddAlbumModal(true);
  };

  const hideAddAlbumModal = () => {
    setOpenAddAlbumModal(false);
  };
  const loadMoreData = () => {
    if (loading) {
      return;
    }
    let newAlbums = allAlbums.slice(
      albums.length,
      albums.length + 50
    );
    setAlbums([...albums, ...newAlbums]);
  };

  useEffect(() => {
    if (!allAlbums.length) {
      setLoading(true);

      Album.getByPage({ page, limit: 9999 , owner:  authService.getCurrentUser().user.id  })
        .then(function (data) {
          console.log(data);
          setAlbums(data.results.slice(0, limit));
          setAllAlbums(data.results);
          setLoading(false);
        })
        .catch((e) => {
          message.error(`An error occured !`);
          setLoading(false);
        });
    }

    return () => {
      // unsubscribe event
    };
  }, []);

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <DefaultLayout
      title={"Albums"}
      subtitle={
        modeSelectEnabled && selectedElements.length
          ? `${selectedElements.length} Selected`
          : allAlbums && allAlbums.length
          ? `${allAlbums.length}`
          : null
      }
    >
      <Spin
        style={{ maxHeight: "85vh", height: "85vh" }}
        spinning={loading}
        delay={500}
      >
        {/* {!loading &&  
       <FloatButton.Group
       shape="circle"
       style={{
         right: 24,
         zIndex: 1 
       }}
     >  
       <FloatButton  tooltip={<div>Add Album</div>}    onClick={() => showAddAlbumModal()}  type="primary" icon={<PlusOutlined />} />
       <FloatButton  tooltip={<div>Select Mode</div>}   type="primary" icon={<CheckSquareOutlined />} />
       
        <FloatButton.BackTop  tooltip={<div>Go to Top</div>} type="primary"  />
     </FloatButton.Group>
        } */}

        {!loading && (
          <FloatButton.Group
            shape="circle"
            style={{
              right: 24,
              zIndex: 1,
            }}
          >
            {!modeSelectEnabled && (
              <FloatButton
                tooltip={<div>Add Album</div>}
                onClick={() => showAddAlbumModal()}
                type="primary"
                icon={<PlusOutlined />}
              />
            )}

            {modeSelectEnabled && selectedElements.length > 0 && (
              <>
                <FloatButton
                  tooltip={<div>Remove</div>}
                  onClick={async () => {
                    setLoading(true);
                    removeAlbums(selectedElements);
                    setModeSelectEnabled(false);
                    setSelectedElements([]);
                  }}
                  type="primary"
                  icon={<DeleteOutlined />}
                />
              </>
            )}
            {modeSelectEnabled && (
              <FloatButton
                tooltip={
                  <div>
                    {selectedElements.length !== albums.length
                      ? "Select All"
                      : "UnSelect All"}
                  </div>
                }
                onClick={() =>
                  setSelectedElements(
                    selectedElements.length === albums.length
                      ? []
                      : allAlbums.map((i) => i.id)
                  )
                }
                type="primary"
                icon={<BlockOutlined />}
              />
            )}
            {allAlbums && allAlbums.length > 0 && (
              <FloatButton
                tooltip={<div>Select Mode</div>}
                onClick={() => {
                  if (!modeSelectEnabled) {
                    setSelectedElements([]);
                  }
                  message.info(
                    "Select Mode " +
                      (!modeSelectEnabled ? "Enabled" : "Disabled")
                  );
                  setModeSelectEnabled(!modeSelectEnabled);
                }}
                type="primary"
                icon={<CheckSquareOutlined />}
              />
            )}

            <FloatButton.BackTop
              tooltip={<div>Go to Top</div>}
              type="primary"
            />
          </FloatButton.Group>
        )}

        <Modal
          title={`Edit Name`}
          open={openEditNameModal}
          onOk={editAlbumName}
          onCancel={hideEditAlbumModal}
          okText="Save"
          cancelText="Cancel"
        >
          <Form>
     

            <Form.Item label="Name">
              <Input
                id="editAlbumName"
                value={editAlbumNameValue}
                 onChange={(e) => setEditAlbumNameValue(e.target.value)}
                placeholder="Album name"
                style={{ width: "100%" }}
              />
              {<></>}
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title="Add Album"
          open={openAddAlbumModal}
          onOk={createAlbum}
          onCancel={hideAddAlbumModal}
          okText="Save"
          cancelText="Cancel"
        >
          <Form>
       
            <Form.Item label="Name">
              <Input
                id="addAlbumWidth"
                value={addAlbumNameValue}
                onChange={(e) => setAddAlbumNameValue(e.target.value)}
                placeholder="Album name"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Form>
        </Modal>

        <Breadcrumb
          style={{
            margin: "30px 0",
          }}
        ></Breadcrumb>

        {albums && (
          <div
            style={{
              overflow: "auto",
              background: albums.length ? "white" : "transparent",
              padding: 20,
              margin: "auto",
            }}
          >
            <InfiniteScroll
              dataLength={albums.length}
              next={loadMoreData}
              hasMore={albums.length < allAlbums.length}
              endMessage={albums.length ? <Divider plain></Divider> : null}
              scrollableTarget="body"
            >
              <List
                dataSource={albums}
                locale={{
                  emptyText: (
                    <Empty
                      description={"Aucun album"}
                      style={{
                        minHeight: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    ></Empty>
                  ),
                }}
                renderItem={(item, index) => {
                  const items = [
                    {
                      key: "1",
                      label: (
                        <a
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentAlbumIndex(index);
                            console.log(index);
                            showEditModal(index);
                          }}
                        >
                          Edit Name
                        </a>
                      ),
                    },
                    {
                      key: "2",
                      label: (
                        <a
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentAlbumIndex(index);
                            removeModal(index);
                          }}
                        >
                          Delete
                        </a>
                      ),
                    },
                  ];

                  return (
                    <div
                      // onDoubleClick={()=> {

                      // }}

                      onClick={(e) => {
                        console.log(e, item, index);
                        if (modeSelectEnabled) {
                          setSelectedElements((prevEls) =>
                            prevEls.includes(item.id)
                              ? prevEls.filter((e) => e !== item.id)
                              : [...prevEls, item.id]
                          );
                        } else {
                          navigate("/album/" + item.id);
                        }
                      }}
                      style={{ padding: 10, display: "inline-block" }}
                    >
                      <Card
                        className="gallery_albums"
                        cover={
                          <div>
                            <Dropdown
                              onClick={(e) => e.stopPropagation()}
                              menu={{ items }}
                            >
                              <MoreOutlined
                                style={{
                                  position: "absolute",
                                  fontSize: 15,
                                  bottom: 10,
                                  right: 10,
                                }}
                              />
                            </Dropdown>
                            <img
                              alt={item.name}
                              src={
                                item.mainImage && item.mainImage.name
                                  ? IMAGEBASEPATH + "images/1/" + item.mainImage.name
                                  : "data:image/png;base64,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"
                              }
                            />
                            {modeSelectEnabled ? (
                              <div
                                className={
                                  selectedElements.includes(item.id)
                                    ? "albums_circleGallery circleGalleryChecked"
                                    : "albums_circleGallery circleGalleryUnchecked"
                                }
                              ></div>
                            ) : null}
                          </div>
                        }
                      >
                        <Meta
                          title={item.name}
                          description={
                            item.images ? item.images.length + "" : "0"
                          }
                        />
                      </Card>
                    </div>
                  );
                }}
              />
            </InfiniteScroll>
          </div>
        )}
        {contextHolder}
      </Spin>
    </DefaultLayout>
  );
};
export default Albums;
